import styled from '@emotion/styled';
import { ReactComponent as TamponJyros } from '../images/jyros-stamp.svg';
import useReportCoverTexts from './useReportCoverTexts';

const GREEN = '#65A08A';
const DARK_BLUE = '#23233D';
const WHITE = '#fff';

const FooterContainer = styled.div<{ backgroundType: 'light' | 'dark' }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  background: transparent;
  padding: 0 2.5rem;
`;

const LeftBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const LogoCircle = styled.div<{ backgroundType: 'light' | 'dark' }>`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg circle {
    stroke: ${({ backgroundType }) =>
      backgroundType === 'light' ? DARK_BLUE : WHITE};
  }

  svg path {
    fill: ${({ backgroundType }) =>
      backgroundType === 'light' ? DARK_BLUE : WHITE};
  }
`;

const VerticalBar = styled.div`
  width: 3px;
  height: 48px;
  background: ${GREEN};
  border-radius: 3px;
`;

const CompanyBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const CompanyName = styled.span<{ backgroundType: 'light' | 'dark' }>`
  color: ${({ backgroundType }) =>
    backgroundType === 'light' ? DARK_BLUE : WHITE};
  font-size: 1.3rem;
  font-family: 'Poppins', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: none;
  margin-bottom: 0.2rem;
`;

const Subtitle = styled.span<{ backgroundType: 'light' | 'dark' }>`
  color: ${GREEN};
  font-size: 0.8rem;
  font-family: 'Poppins', Arial, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.01em;
`;

const RightBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const PageText = styled.span<{ backgroundType: 'light' | 'dark' }>`
  color: ${({ backgroundType }) =>
    backgroundType === 'light' ? DARK_BLUE : WHITE};
  font-size: 1.3rem;
  font-family: 'Poppins', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
`;

const PageBar = styled.div`
  width: 3px;
  height: 24px;
  background: ${GREEN};
  border-radius: 3px;
`;

export const Footer = ({
  year,
  pageNumber,
  backgroundType = 'dark',
}: {
  year: number | undefined;
  pageNumber?: number | undefined;
  backgroundType?: 'light' | 'dark';
}) => {
  const { title, companyText } = useReportCoverTexts('simple', year);
  return (
    <FooterContainer backgroundType={backgroundType}>
      <LeftBlock>
        <LogoCircle backgroundType={backgroundType}>
          <TamponJyros />
        </LogoCircle>
        <VerticalBar />
        <CompanyBlock>
          <CompanyName backgroundType={backgroundType}>
            {companyText}
          </CompanyName>
          <Subtitle backgroundType={backgroundType}>{title}</Subtitle>
        </CompanyBlock>
      </LeftBlock>
      {pageNumber && (
        <RightBlock>
          <PageText backgroundType={backgroundType}>P. {pageNumber}</PageText>
          <PageBar />
        </RightBlock>
      )}
    </FooterContainer>
  );
};
